import React from 'react'
import AiHero from '../../Components/Automation/AiHero'
import OurServiceOffer from '../../Components/Automation/OurServiceOffer'
import { ChevronRight } from 'lucide-react'
import Perspectives from '../../Components/Accelerating/Perspectives'
import RelatedServices from '../../Components/Accelerating/RelatedServices'
import AccContact from '../../Components/Accelerating/AccContact'
import Banner from '../../Components/Banner'
import { Helmet } from 'react-helmet-async'
import ContactSection from '../../Components/home/ContactSection'

const relatedService = [
    {
        id: 1,
        title: "ServiceNow Digital Workflows",
        description: "At Mobikode, we help you make IT and HR work easier with ServiceNow. Our automated workflows reduce manual effort, improve efficiency, and keep your operations running smoothly without the usual complexity.",
        image: "/assets/product/p1.png",
        link: "/servicenow-digital-workflows"
    },
    {
        id: 2,
        title: "Embedded Systems & Industrial",
        description: "We build reliable embedded software and industrial IoT solutions that bring next-generation connected hardware to life with smarter performance and real-world reliability.",
        image: "/assets/product/p3.png",
        link: "/embedded-systems-industrial"
    },
    {
        id: 3,
        title: "Quality Engineering & Performance",
        description: "We focus on continuous testing and performance engineering to make sure every release is smooth, fast, and reliable. Our goal is simple, deliver software that works flawlessly and gives users a seamless experience every time.",
        image: "/assets/product/p4.png",
        link: "/quality-engineering-performance"
    },
    {
        id: 4,
        title: "Enterprise Applications & ERP",
        description: "Bring all your business data together and simplify daily operations with custom-built ERP systems designed to make work easier, faster, and more efficient.",
        image: "/assets/product/p2.png",
        link: "/enterprise-applications-erp"
    }
];

const data = [
    {
        id: 1,
        category: "DIGITAL TRANSFORMATION",
        title: "Why Headless CMS is the Future of Content Delivery",
        link: "#"
    },
    {
        id: 2,
        category: "USER EXPERIENCE",
        title: "The Impact of Micro-Interactions on User Retention",
        link: "#"
    },
    {
        id: 3,
        category: "MOBILE FIRST",
        title: "React Native vs. Flutter: Choosing the Right Cross-Platform Framework",
        link: "#"
    },
    {
        id: 4,
        category: "PRODUCT STRATEGY",
        title: "From MVP to Scale: Engineering Principles for Growth",
        link: "#"
    }
];

const service = [
    {
        id: 1,
        title: "Web & Mobile App Development",
        category: "service",
        desc: "We build fast, responsive web and mobile applications that feel smooth to use, are easy to navigate, and truly fit your users’ needs while supporting your business goals.",
        defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]",
        link: "/",
    },
    {
        id: 2,
        title: "ReactJS / Full Stack Engineering",
        category: "service",
        desc: "We create scalable and reliable applications using modern React and full-stack technologies, focusing on clean design, smooth performance, and real business needs.",
        defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]",
        link: "/",
    },
    {
        id: 3,
        title: "CMS (Strapi / Sanity / Headless)",
        category: "service",
        desc: "We build flexible headless CMS solutions that make it easy to manage and share content smoothly across all your digital channels, ensuring consistency, speed, and scalability.",
        defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]",
        link: "/",
    },
    {
        id: 4,
        title: "UI/UX & Experience Design",
        category: "service",
        desc: "Designing simple, intuitive, and engaging user experiences that feel natural to use, keep customers happy, and build lasting loyalty.",
        defaultBg: "bg-gradient-to-bl from-[#01386A] to-[#6A85B6]",
        link: "/",
    },
    {
        id: 5,
        title: "API Development & Integrations",
        category: "service",
        desc: "We build secure, scalable APIs that connect different systems effortlessly, ensuring smooth and reliable data flow across your digital ecosystem.",
        defaultBg: "bg-gradient-to-tr from-[#01386A] to-[#253B5C]",
        link: "/",
    }
]

function ProductEngineeringDigital() {
    return (
        <div>
            <Helmet>
    <title>
        Product Engineering Services | Digital Product Development | Mobikode
    </title>

    <meta
        name="description"
        content="Mobikode delivers product engineering and digital development services to build scalable web and mobile applications, modern user experiences, headless CMS platforms, and reliable API-driven solutions."
    />

    <meta
        name="keywords"
        content="Product Engineering Services, Product Engineering Company, Digital Product Development, Web Application Development, Mobile App Development, ReactJS Development, Full Stack Development, Headless CMS Development, Strapi Development, Sanity CMS Development, UI UX Design Services, API Development Services, API Integration Services, Digital Product Engineering, Scalable Application Development"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/capabilities/product-engineering"
    />

    <meta
        property="og:title"
        content="Product Engineering Services | Digital Product Development | Mobikode"
    />

    <meta
        property="og:description"
        content="Build reliable, scalable, and user-focused digital products with Mobikode's product engineering services. From web and mobile apps to React, headless CMS, UI/UX, and API integrations."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/capabilities/product-engineering"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/what/c6.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Product Engineering Services | Digital Product Development | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Explore Mobikode's product engineering solutions for web and mobile development, ReactJS and full-stack engineering, headless CMS, UI/UX design, and API development."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/what/c6.png"
    />
</Helmet>
            <AiHero title="Product Engineering" imgData="/assets/what/c6.png" />
            <section className="w-full py-[50px] lg:py-[80px] bg-white overflow-hidden relative">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
                    <div className="relative w-full flex flex-col lg:flex-row h-auto lg:h-[323px] group">

                        <div className="overflow-hidden w-full lg:max-w-[624px] h-[250px] lg:h-full relative z-10">
                            <img
                                src="/assets/what/item16.png"
                                alt="Digital Product Engineering"
                                className="w-full h-full object-cover mix-blend-multiply transition-transform duration-700 group-hover:scale-105"
                            />
                        </div>

                        <div className="relative z-20 w-full lg:max-w-[656px] bg-white shadow-[0_10px_40px_rgba(0,0,0,0.1)] 
                            px-[20px] py-[30px] lg:px-[40px] lg:py-[30px] flex flex-col justify-center
                            -mt-6 lg:mt-0 lg:ml-0">
                            <p className="text-[#49577A] w-full text-[14px] lg:text-[16px] leading-[1.6] font-[500] font-graphik text-justify">
                                At Mobikode, we see your digital product as more than just software, it's your brand in action. That’s why we blend practical design thinking with solid product engineering to build experiences people actually enjoy using. Whether it’s fast, reliable web platforms, smooth mobile apps, or scalable enterprise systems, we focus on making things simple, useful, and well-crafted. Every detail matters to us because it directly shapes how your users feel about your brand and how your business grows.
                            </p>
                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                            <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>

                        </div>

                    </div>
                </div>
            </section>
            <OurServiceOffer service={service} />
            {/* <section className='overflow-hidden'>
                <div className="max-w-[1440px] lg:pb-[80px] pb-[40px] w-full mx-auto lg:px-[80px] px-[20px]">
                    <h6 className="text-center font-[600] lg:text-[31px] text-[20px] lg:pb-[80px] pb-[40px] lg:leading-[40px] leading-[30px] text-[#01386A]">Spotlight</h6>

                    <div className="flex lg:flex-row flex-col gap-5">

                        <div className="w-full lg:w-[65%] mx-auto relative group">
                            <div className="relative w-full h-[350px] lg:h-auto lg:aspect-auto">
                                <img src="/assets/what/img6.png" className="w-full h-full object-cover" alt="" />
                                <div className="absolute top-0 left-0 w-full h-full bg-[#00000033]"></div>
                                <div className="absolute top-0 left-0 p-[20px] lg:p-[40px] w-full h-full flex flex-col justify-between">
                                    <p className="font-[500] font-graphik text-[16px] lg:text-[18px] leading-[24px] text-[#FFFFFF]">CASE STUDY</p>
                                    <div>
                                        <h6 className="font-[500] font-graphik text-[20px] lg:text-[24px] leading-[26px] lg:leading-[30px] text-[#FFFFFF] max-w-[666px] w-full pb-[20px]">Revamping the Digital Experience for a Global Retail Giant</h6>
                                        <div className="flex items-center gap-2 font-graphik font-[500] text-[16px] text-[#FFFFFF]">
                                            <span>Read More</span>
                                            <ChevronRight size={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="w-full lg:w-[35%] mx-auto grid gap-[20px]">

                            <div className="relative h-[300px] lg:h-auto">
                                <img src="/assets/what/img5.png" className="w-full h-full object-cover" alt="" />
                                <div className="absolute top-0 left-0 w-full h-full bg-[#00000033]"></div>
                                <div className="absolute top-0 left-0 p-[20px] lg:p-[40px] w-full h-full flex flex-col justify-between">
                                    <p className="font-[500] font-graphik text-[16px] lg:text-[18px] leading-[24px] text-[#FFFFFF]">CASE STUDY</p>
                                    <div>
                                        <h6 className="font-[500] font-graphik text-[20px] lg:text-[24px] leading-[26px] lg:leading-[30px] text-[#FFFFFF] max-w-[666px] w-full pb-[20px] line-clamp-2">
                                            Building a Scalable Fintech App with React Native...
                                        </h6>
                                        <div className="flex items-center gap-2 font-graphik font-[500] text-[16px] text-[#FFFFFF]">
                                            <span>Read More</span>
                                            <ChevronRight size={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="relative h-[300px] lg:h-auto">
                                <img src="/assets/what/img7.png" className="w-full h-full object-cover" alt="" />
                                <div className="absolute top-0 left-0 w-full h-full bg-[#00000033]"></div>
                                <div className="absolute top-0 left-0 p-[20px] lg:p-[40px] w-full h-full flex flex-col justify-between">
                                    <p className="font-[500] font-graphik text-[16px] lg:text-[18px] leading-[24px] text-[#FFFFFF]">CASE STUDY</p>
                                    <div>
                                        <h6 className="font-[500] font-graphik text-[20px] lg:text-[24px] leading-[26px] lg:leading-[30px] text-[#FFFFFF] max-w-[666px] w-full pb-[20px] line-clamp-2">
                                            Implementing a Headless CMS for Multi-Channel Content...
                                        </h6>
                                        <div className="flex items-center gap-2 font-graphik font-[500] text-[16px] text-[#FFFFFF]">
                                            <span>Read More</span>
                                            <ChevronRight size={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section> */}
            <section className="w-full pb-[40px] lg:pb-[80px] bg-white overflow-hidden relative">
                <div className="max-w-[1440px] mx-auto px-[15px] lg:px-[80px]">
                    <div className="relative w-full flex flex-col lg:flex-row lg:items-center group lg:h-[507px]">
                        <div className="relative lg:absolute top-0 right-0 w-full lg:max-w-[656px] h-[250px] md:h-[350px] lg:h-full bg-gray-100 overflow-hidden">
                            <img
                                src="/assets/what/img8.png"
                                alt="Mobikode Digital Engineering"
                                className="w-full h-full object-cover mix-blend-multiply transition-transform duration-700 group-hover:scale-105"
                            />
                        </div>
                        <div className="relative z-20 w-[92%] sm:w-[85%] lg:w-full max-w-[719px] mx-auto lg:mx-0 bg-white shadow-[0_10px_40px_rgba(0,0,0,0.1)] px-[20px] py-[30px] lg:px-[60px] lg:py-[80px] -mt-[40px] lg:mt-0">
                            <h3 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] font-sora mb-[15px] lg:mb-[35px] leading-[1.3]">
                                The Mobikode Digital Advantage
                            </h3>
                            <p className="text-[#49577A] w-full text-[14px] lg:text-[16px] leading-[1.6] font-graphik font-[500] text-justify">
                                At Mobikode, we go beyond writing code, we design meaningful digital experiences. Our Product Engineering team builds high-impact solutions aligned with your business goals. Using modern technologies like React, Next.js, and headless architectures, we create fast, scalable, and future-ready applications. From idea to deployment, we work closely with you to turn vision into reliable, user-focused digital products that drive real value.
                            </p>
                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                            <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <Perspectives data={data} /> */}
            <RelatedServices relatedService={relatedService} />
            {/* <section className='relative'>
                <img src="/assets/product/bg1.jpg" className='lg:h-[683px] h-[800px] w-full object-cover' alt="" />
                <div className="max-w-[1440px] w-full mx-auto lg:px-[80px] px-[20px] top-1/2 -translate-y-1/2 absolute left-1/2 -translate-x-1/2">
                    <AccContact />
                </div>
            </section> */}
            <Banner title="Product Engineering" text=" Empowering businesses with intelligent, autonomous AI solutions that drive efficiency and innovation." />
            <ContactSection/>
        </div>
    )
}

export default ProductEngineeringDigital